<template>
  <div id="sidebar">
    <div class="sidebar-inner slimscroll">
      <div id="sidebar-menu" class="sidebar-menu">
        <ul>
          <li v-for="(item, i) in items" :key="i + '-nav-item'">
            <router-link :to="item.to" v-if="item.isAllowed" :title="item.text">
                <i :class="item.icon" :title="item.text"></i>
              <span class="menu-text">{{ item.text }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    hoverOn() {
      this.$emit("hoverOn");
    },
    hoverOff() {
      this.$emit("hoverOff");
    },
  },
};
</script>

<style lang="css" scoped>
#sidebar {
  height: 100%;
  background-color: #fff;
  z-index: 900;
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 0.3s ease;
}

.sidebar-inner {
  height: 100%;
  padding: 1rem 0;
  transition: all 0.2s ease-in-out;
}

.sidebar-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu li {
  margin: 0;
}

.sidebar-menu li a {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  position: relative;
  white-space: nowrap;
}

.sidebar-menu li a:hover {
  background-color: #f8f9fa;
  color: #009efb;
  border-left-color: #009efb;
}

.sidebar-menu li a.router-link-active {
  background-color: rgba(0, 158, 251, 0.1);
  color: #009efb;
  border-left-color: #009efb;
  font-weight: 500;
}

.sidebar-menu li a i {
  margin-right: 12px;
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}

.sidebar-menu li a .menu-text {
  margin-left: 0;
  font-size: 0.9rem;
  font-weight: 400;
  opacity: 1;
  transition: opacity 0.3s ease;
}

/* Collapsed sidebar styles */
.sidebar-container.sidebar-hidden #sidebar {
  width: 60px;
}

.sidebar-container.sidebar-hidden .sidebar-menu li a {
  padding: 12px 20px;
  justify-content: center;
}

.sidebar-container.sidebar-hidden .sidebar-menu li a .menu-text {
  opacity: 0;
  visibility: hidden;
  width: 0;
  margin: 0;
}

.sidebar-container.sidebar-hidden .sidebar-menu li a i {
  margin-right: 0;
}

/* Tooltip styles for collapsed sidebar */
.sidebar-container.sidebar-hidden .sidebar-menu li a::after {
  content: attr(title);
  position: absolute;
  left: 70px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  pointer-events: none;
}

.sidebar-container.sidebar-hidden .sidebar-menu li a::before {
  content: '';
  position: absolute;
  left: 62px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #333;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
}

.sidebar-container.sidebar-hidden .sidebar-menu li a:hover::after,
.sidebar-container.sidebar-hidden .sidebar-menu li a:hover::before {
  opacity: 1;
  visibility: visible;
}

/* Scrollbar styling */
.slimscroll::-webkit-scrollbar {
  width: 6px;
}

.slimscroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.slimscroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.slimscroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
